import { Link } from "react-router-dom";
import { galleryItems } from "@/mocks/gallery";

const previewImages = galleryItems.slice(0, 6);

export default function GalleryPreview() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs tracking-[0.2em] text-secondary-500 mb-2 font-medium">
              精彩图集
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
              精美写真欣赏
            </h2>
          </div>
          <Link
            to="/category/gallery"
            className="hidden sm:flex items-center gap-1 text-sm text-secondary-500 hover:text-secondary-600 transition-colors whitespace-nowrap"
          >
            浏览图集 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {previewImages.map((item, index) => (
            <Link
              key={item.id}
              to="/category/gallery"
              className={`group relative rounded-xl overflow-hidden ${
                index === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <div className={`${index === 0 ? "aspect-[16/9] md:aspect-auto md:h-full" : "aspect-[4/5]"}`}>
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <div>
                  <p className="text-white text-sm font-medium">{item.title}</p>
                  <p className="text-white/70 text-xs">{item.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/gallery"
            className="inline-flex items-center gap-1 text-sm text-secondary-500 hover:text-secondary-600 transition-colors whitespace-nowrap"
          >
            浏览更多图片 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}